import { render, staticRenderFns } from "./AppointmentAnamnesisDetails.vue?vue&type=template&id=11a9b475"
import script from "./AppointmentAnamnesisDetails.vue?vue&type=script&lang=js"
export * from "./AppointmentAnamnesisDetails.vue?vue&type=script&lang=js"
import style0 from "./AppointmentAnamnesisDetails.vue?vue&type=style&index=0&id=11a9b475&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports